const middlewares = [];

function initWebflow(config) {
	document.addEventListener("DOMContentLoaded", function() {
		const wf = (window.Webflow && window.Webflow.require("ix2")) || {};
		if (wf) {
			wf.store.dispatch = _wrapDispatch(wf.store.dispatch);
			wf.init(config);
		}
	});
}

function addMiddleware(fn) {
	middlewares.push(fn);
}

function removeMiddleware(fn) {
	for (let i = 0; i < middlewares.length; i++) {
		if (middlewares[i] === fn) {
			middlewares.splice(i, 1);
			return i;
		}
	}
}

function _doMiddleware(action) {
	for (let i = 0; i < middlewares.length; i++) {
		if (typeof middlewares[i] === "function") {
			action = middlewares[i](action) || action;
		}
	}

	return action;
}

function _wrapDispatch(dispatch) {
	return function(action) {
		action = _doMiddleware(action);
		dispatch(action);
	};
}

module.exports = {
	addMiddleware,
	initWebflow,
	removeMiddleware,
};
